import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/product/cost-down.svg");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/product/cost-turn.svg");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/product/select-product.svg");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Typography/Typography.js");
